import { StyleSheet } from "react-native";

/**
 * Mobile-only (iPhone) overrides for the Submit Ticket screens.
 * Applied when Platform.OS === "ios" && windowWidth < 768.
 * Does NOT affect web or iPad.
 */
const mobileSubmitStyles = StyleSheet.create({
  /* ── Screen root ─────────────────────────────────────────── */
  screenRoot: {
    flex: 1,
    backgroundColor: "#f0f4fa", // overridden to dark bg in dark mode via inline style
  },
  container: {
    flex: 1,
    paddingHorizontal: 0,
    paddingTop: 0,
  },

  /* ── Header block ────────────────────────────────────────── */
  headerBlock: {
    marginBottom: 18,
    backgroundColor: "#ffffff",
    paddingHorizontal: 16,
    paddingVertical: 14,
  },
  breadcrumbRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginBottom: 4,
  },
  backArrowWrap: {
    padding: 2,
  },
  breadcrumbLinkText: {
    fontSize: 13,
    fontWeight: "600",
    color: "#005cbc",
  },
  breadcrumbSeparator: {
    fontSize: 13,
    color: "#818181",
    marginHorizontal: 2,
  },
  breadcrumbCurrent: {
    fontSize: 13,
    color: "#656565",
    fontWeight: "500",
  },
  title: {
    fontSize: 18,
    fontWeight: "700",
    color: "#2D2D2D",
    lineHeight: 28,
  },
  subtitle: {
    fontSize: 12,
    color: "#656565",
    lineHeight: 18,
    marginLeft: 32,
  },

  /* ── Check for Existing Issues card ─────────────────────── */
  existingCard: {
    backgroundColor: "#ffffff",
    borderRadius: 14,
    paddingVertical: 18,
    paddingHorizontal: 16,
    marginHorizontal: 16,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: "#daeefa",
  },
  existingCardHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    marginBottom: 8,
  },
  existingIconWrap: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: "#daeefa",
    alignItems: "center",
    justifyContent: "center",
  },
  panelTitle: {
    fontSize: 15,
    fontWeight: "700",
    color: "#1a2332",
  },
  panelSubtitle: {
    fontSize: 13,
    color: "#585858",
    lineHeight: 19,
    marginBottom: 14,
  },
  searchWrap: {
    position: "relative",
    marginBottom: 12,
  },
  searchIcon: {
    position: "absolute",
    left: 12,
    top: 12,
    zIndex: 2,
  },
  searchInput: {
    backgroundColor: "#ffffff",
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 10,
    paddingLeft: 38,
    paddingRight: 12,
    paddingVertical: 10,
    height: 44,
    fontSize: 14,
    color: "#2d2d2d",
  },
  existingTicket: {
    borderWidth: 1,
    borderColor: "#e6e6e6",
    borderRadius: 10,
    paddingVertical: 12,
    paddingHorizontal: 14,
    marginBottom: 8,
    backgroundColor: "#ffffff",
  },
  existingTicketBody: {
    flex: 1,
  },
  existingTicketTop: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  existingTicketBodyLeft: {
    flex: 1,
    marginRight: 8,
  },
  ticketId: {
    fontSize: 12,
    fontWeight: "700",
    color: "#005cbc",
    marginBottom: 3,
  },
  ticketTitle: {
    fontSize: 14,
    fontWeight: "600",
    color: "#1a2332",
    lineHeight: 19,
    marginBottom: 8,
  },
  existingMetaRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
  },
  ticketMeta: {
    fontSize: 12,
    color: "#585858",
  },
  affectedButton: {
    backgroundColor: "#005CBC",
    borderRadius: 100,
    paddingHorizontal: 14,
    paddingVertical: 8,
    alignItems: "center",
    alignSelf: "flex-start",
  },
  affectedButtonDisabled: {
    backgroundColor: "#E6E6E6",
  },
  affectedButtonText: {
    fontSize: 12,
    fontWeight: "700",
    color: "#ffffff",
  },
  affectedButtonTextDisabled: {
    color: "#818181",
  },

  /* ── Form panel (Ticket Details section) ────────────────── */
  formSection: {
    marginBottom: 16,
  },
  formSectionTitle: {
    fontSize: 18,
    fontWeight: "700",
    color: "#1a2332",
    marginBottom: 2,
  },
  formSectionSubtitle: {
    fontSize: 12,
    color: "#818181",
    marginBottom: 16,
  },
  formCard: {
    backgroundColor: "#ffffff", // overridden in dark mode via inline style
    borderRadius: 14,
    paddingHorizontal: 16,
    paddingVertical: 18,
    marginHorizontal: 16,
    marginBottom: 16,
  },

  /* ── Footer action row (sticky bottom bar) ──────────────── */
  footerActions: {
    backgroundColor: "#ffffff", // overridden in dark mode via inline style
    paddingHorizontal: 16,
    paddingTop: 14,
    paddingBottom: 28,
    borderTopWidth: 1,
    borderTopColor: "#e8e8e8",
    flexDirection: "column",
    gap: 10,
  },
  btnCancel: {
    borderRadius: 100,
    paddingVertical: 13,
    paddingHorizontal: 14,
    alignItems: "center",
  },
  btnCancelText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#4b4b4b", // overridden in dark mode via inline style
  },
  btnDraft: {
    borderRadius: 100,
    paddingVertical: 13,
    paddingHorizontal: 14,
    backgroundColor: "#ffffff",
    borderWidth: 1.5,
    borderColor: "#034895",
    alignItems: "center",
  },
  btnDraftText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#034895",
  },
  btnSubmit: {
    borderRadius: 100,
    paddingVertical: 13,
    paddingHorizontal: 14,
    backgroundColor: "#034895",
    alignItems: "center",
  },
  btnSubmitText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#ffffff",
  },
});

export default mobileSubmitStyles;
